(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avolt-sticky-buy-button"] && !Shopify.designMode) return;
  try {
    (() => {
    let boundChatApi;
    const bindChatEvents = () => {
      const chatApi = window.tidioChatApi;
      if (!chatApi || chatApi === boundChatApi) return;
      boundChatApi = chatApi;
      chatApi.on('open', () => {
        document.documentElement.setAttribute('data-avolt-chat-open', 'true');
      });
      chatApi.on('close', () => {
        document.documentElement.removeAttribute('data-avolt-chat-open');
      });
    };
    if (window.tidioChatApi) window.tidioChatApi.on('ready', bindChatEvents);
    document.addEventListener('tidioChat-ready', bindChatEvents);
    bindChatEvents();
  })();
  } catch(e) { console.error(e); }
})();

})();
